import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierService } from "app/services/carrier.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { MonthlyComplianceFilterConfig } from "app/shared/filter/filter.constant";
import { ToastrService } from "ngx-toastr";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { MonthlyComplianceService } from 'app/services/monthly-compliance.service';
import { AnnualComplianceService } from 'app/annual-compliance/service/annual-compliance.service';
import * as moment from 'moment';
import { environment } from 'environments/environment';
declare var window: any;


@Component({
  selector: 'app-monthly-compliance-list',
  templateUrl: './monthly-compliance-list.component.html',
  styleUrls: ['./monthly-compliance-list.component.scss']
})
export class MonthlyComplianceListComponent implements OnInit {
  isLoading: boolean = false;
  user: any = {};
  selectedPermitData: any = [];
  selectedPermitIds: any = [];
  selectedComplianceId: any=[];
  permits;
  isEmpty: boolean = true;
  closeResult: string = "";
  carrierId;
  count: number;
  pageSize: number = 10;
  currentPage: number = 1;
  disableDuplicate: boolean = false;
  disableCertificate: boolean = false;
  carrierDetails: any;
  isFilteredDataEmpty: boolean = false;
  Statuses: any;
  selectedItems: any = [];
  selectedItemsTo: any = [];
  keyword: any = {};
  filterConfig = MonthlyComplianceFilterConfig;
  months: string[];
    IsSearching: boolean = false;
    message: string = 'Loading  permits, please wait...';
    status: string = "";
    isExternalRole: boolean = false;
    isAdmin: boolean = false;
     


  constructor(
    private authWebService: AuthWebService,
    private _router: Router,
    private _toaster: ToastrService,
    private toastService: ToastNotificationService,
    private monthlyComplianceService: AnnualComplianceService,
    private monthlyCompliance: MonthlyComplianceService,
    private _activatedRoute: ActivatedRoute,
    private _carrier: CarrierService,
    public utility: UtilityServiceService
  ) {
    
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
  }

  ngOnInit(): void {
    this.carrierId = this._activatedRoute.snapshot.paramMap.get("id");
  // if (this.carrierId) 
   const startingDate = new Date();
  this.months = this.generateMonthHeadings(6, startingDate);
    this.utility.page = 1;
    if (this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = true;
    }
    
    if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
      this.isAdmin = true;

  }
    const storedFilters = window.localStorage.getItem('monthlyComplianceFilters');
    console.log('Stored filters:', storedFilters);
    if (storedFilters) {
      const filters = JSON.parse(storedFilters);
      this.applyFilter(filters);
    } else {
      this.getList();
    }
  
  }
  private generateMonthHeadings(numMonths: number, startingDate: Date): string[] {
    const headings: string[] = [];
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    for (let i = 0; i < numMonths; i++) {
      const currentDate = new Date(startingDate.getFullYear(), startingDate.getMonth() - i, 1);
      const month = currentDate.getMonth();
      const year = currentDate.getFullYear();
      headings.unshift(`${monthNames[month]} ${year}`);
    }
    
    return headings;
  }
  
  onBack() {

        this._router.navigateByUrl('admin/monthly-compliance');
    

}

  

navigate(carrierId,permitId,complianceId)
{
 // this._router.navigate(['carrier/monthly-returns', carrierId, permitId, complianceId]);
  this._router.navigate(['carrier/monthly-returns/'+ carrierId + "/" + permitId+ "/" + complianceId]);
}

  getList() {
    this.isLoading = true;
    let url = `${this.currentPage}/${this.pageSize}`;
    this.monthlyCompliance.getcarrierlist(this.carrierId, url).subscribe(
      (res: any) => {
        console.log("Response:", res);
        if (res) {
          this.permits = res.Permits;
          console.log(" the reso",this.permits)
          this.count = res.TotalRecords;
          console.log("permits", this.permits);
          this.permits.forEach((permit: any) => {
            // Access the MonthlyData array within each permit
            permit.MonthlyData.forEach((monthlyData: any) => {
              // Access the properties within MonthlyData
            //  console.log("yyyy_mm:", monthlyData.yyyy_mm);
//console.log("status_ind:", monthlyData.status_ind);
              // ... Continue accessing other properties as needed
            });
          });
        } else {
          this.isEmpty = true;
          this.permits = []; // Clear the permits array
          this.count = 0;
          this.isLoading = false;
          this.utility.page = this.currentPage; // Set page back to the previous one
          this.isFilteredDataEmpty = true;
          this.getCarrierDataById();
        }
        this.isLoading = false;
      },
      (err) => {
        this.isEmpty = true;
        this.getCarrierDataById();
        this.isLoading = false;
        console.error(err);
      }
    );
  }
  

  onReset = () => {
    this.message = 'Loading permits, please wait...';
    this.utility.page = 1;
    this.IsSearching = false;
    const startingDate = new Date();
    this.months = this.generateMonthHeadings(6, startingDate);
    this.getList();
};
////////////////////////////////////////

onSearch() {
  this.isLoading = true;
  let url = `${this.currentPage}/${this.pageSize}`;
  let body = this.keyword;
  this.monthlyComplianceService.getListMonthlyCompliance(url, body).subscribe(
    (result: any) => {
      this.permits = result;
      this.count = result.TotalCount;
      this.isFilteredDataEmpty = false;
      this.utility.onSort(1);
      this.isLoading = false;
      if (result.TotalCount == 0) this.isFilteredDataEmpty = true;
    },
    (error) => {
      this.permits = [];
      this.isLoading = false;
      this.isFilteredDataEmpty = true;
    }
  );
}
applyFilter(filters) {
  this.resetPages();
  if (!filters) {
    this.keyword = {};
    this.saveFiltersToLocalStorage(this.keyword);
    this.isFilteredDataEmpty = false;

    console.log('Applying filters:', filters);
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 6);
    const formattedStartMonth = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    this.keyword.StartMonth = formattedStartMonth;

    this.getList();
  } else {
   

    this.keyword.StartMonth = ""; // Reset the starting month
  
      if (filters.StartMonth) {
        const monthYearPattern = /^(January|February|March|April|May|June|July|August|September|October|November|December) \d{4}$/;
        
        if ( !(monthYearPattern.test(filters.StartMonth))) {
          console.log("starting month",filters.StartMonth)
        //  return new Error("StartMonth should be in the format 'Month Year', e.g., 'July 2023'");
          return this.toastService.error("StartMonth should be in the format 'Month Year', e.g., 'July 2023'.", "error");
      }
      const parsedDate = new Date(filters.StartMonth);
      const formattedStartMonth = `${parsedDate.getFullYear()}${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}`;
      this.keyword.StartMonth = formattedStartMonth;
        const startingDate = new Date(filters.StartMonth);
      this.months = this.generateMonthHeadings(6, startingDate);
      }  
    this.keyword.PermitNumber = filters?.PermitNumber
      ? filters.PermitNumber
      : "All";
    this.keyword.PermitType =
      filters?.PermitType
        ? filters?.PermitType
        : "All";
        this.keyword.carrier_id = this.carrierId;
        
        this.keyword.BorderCrossing =
        filters?.BorderCrossing
          ? filters?.BorderCrossing
          : "All";
          this.keyword.TempLong = filters?.TempLong === "temp" ? 1 : filters?.TempLong === "longterm" ? 2 : 0;

          this.keyword.FreightPassenger = filters?.FreightPassenger === "freight" ? 1 : filters?.FreightPassenger === "passenger" ? 2 : 0;
          this.saveFiltersToLocalStorage(filters);
  
    if (filters) {
    //  this.months = this.generateMonthHeadings(6, new Date(filters.StartMonth));
      this.getFilterResponse();
    } else {
      this.getList();
    }
  }
}
private saveFiltersToLocalStorage(filters: any): void {
  localStorage.setItem('monthlyComplianceFilters', JSON.stringify(filters));
}

onNextOrPrevious(page: number = 1) {
  this.currentPage = page;
  const startingDate = new Date();
  this.message = "Loading  permits, please wait...";
  this.months = this.generateMonthHeadings(6, startingDate);
  if (Object.keys(this.keyword).length > 0) {
    this.getFilterResponse();
  } else {
    this.getList();
     this.utility.page = page;
  }
  this.utility.page = page;
  return page;
}

onChange(event) {
  this.currentPage = 1;
  this.pageSize = event;
  const startingDate = new Date();
  this.months = this.generateMonthHeadings(6, startingDate);
  if (Object.keys(this.keyword).length > 0) {
    this.getFilterResponse();
  } else {
    this.getList();
  }
}
getFilterResponse() {
  this.isLoading = true;
  let url = `${this.currentPage}/${this.pageSize}`;
  let body = this.keyword;
  this.monthlyComplianceService.getListMonthlyCompliance(url, body).subscribe(
    (result: any) => {
      this.permits = result.Permits;
      this.count = result.TotalCount;
      this.isFilteredDataEmpty = false;
      this.utility.onSort(1);
      this.isLoading = false;
      if (result.TotalCount == 0) this.isFilteredDataEmpty = true;
    },
    (error) => {
      this.permits = [];
      this.isLoading = false;
      this.isFilteredDataEmpty = true;
    }
  );
}

 
  onChanges(event) {
    this.currentPage = 1;
    this.pageSize = event.target.value;
    this.selectedPermitData = [];
    //this.selectedPermitIds = [];
    this.selectedComplianceId=[];
 
  }

  // private generateMonthHeadings(numMonths: number): string[] {
  //   const today = new Date();
  //   const monthNames = [
  //     "January", "February", "March", "April", "May", "June",
  //     "July", "August", "September", "October", "November", "December"
  //   ];
  //   const headings: string[] = [];

  //   for (let i = 0; i < numMonths; i++) {
  //     const month = (today.getMonth() - i + 12) % 12; // Handle wrapping around to previous year
  //     const year = today.getFullYear() - Math.floor((today.getMonth() - i) / 12);

  //     headings.unshift(`${monthNames[month]} ${year}`);
  //   }

  //   return headings;
  // }

  onChangePage(event) {
    this.utility.page = event;
    this.selectedPermitData = [];
    this.selectedComplianceId=[];
  //  this.selectedPermitIds = [];
  }

  resetPages() {
    this.pageSize = 10;
    this.currentPage = 1;
  }

  

  getCarrierDataById() {
    this._carrier.getCarrierById(this.carrierId).subscribe((res) => {
      this.carrierDetails = res;
    });
  }

  hasMonthlyData(permit: any, month: string): boolean {
    return permit.MonthlyData.some(
      monthlyData => this.getMonthFromDate(monthlyData.yyyy_mm) === month
    );
  }

  getMonthlyStatus(permit: any, month: string): string {
    const monthlyData = permit.MonthlyData.find(
      monthlyData => this.getMonthFromDate(monthlyData.yyyy_mm) === month
    );
    console.log("status ind", monthlyData.status_ind)
    return monthlyData ? monthlyData.status_ind.toString() : '';
  }

  getMonthFromDate(yyyy_mm: number): string {
    const year = Math.floor(yyyy_mm / 100);
    const month = yyyy_mm % 100;
    const date = new Date(year, month - 1, 1); // Subtract 1 from month since JavaScript uses 0-based indexing for months
    const formattedMonth = date.toLocaleString('default', { month: 'long', year: 'numeric' });
    return formattedMonth;
  }
  
  


  

}

